import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, Fragment as _Fragment, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'
import _imports_1 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-71623518")

_pushScopeId("data-v-71623518")
const _hoisted_1 = {
  key: 0,
  ref: "pseudoInput",
  class: "absolute pointer-events-none",
  style: {"opacity":"0"}
}
const _hoisted_2 = {
  src: _imports_0,
  class: "w-5 mr-3",
  alt: "exclamation circle solid"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 mr-3",
  alt: "check"
}, null, -1)
const _hoisted_4 = { class: "absolute left-0 bottom-0 px-4 py-4" }
const _hoisted_5 = { class: "text-12px " }
const _hoisted_6 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_7 = {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", {
      class: 
      _ctx.labelStackedCenter
        ? 'inline-block relative w-full'
        : 'inline-block relative w-full flex flex-row'
    
    }, [
      (_ctx.isFirstInput)
        ? (_openBlock(), _createBlock("input", _hoisted_1, null, 512))
        : _createCommentVNode("", true),
      (_ctx.type !== 'textarea')
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            (_ctx.iconLeft)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: `border-l border-t border-b border-r-none rounded-l-md flex items-center my-1.5 pl-4 ${
            _ctx.error || _ctx.errorMaxValueNumber || _ctx.errorMandatory
              ? 'border-red-lp-100'
              : 'border-gray-lp-400'
          }`
                }, [
                  _createVNode("img", {
                    alt: _ctx.iconLeft,
                    src: require(`@/app/ui/assets/svg/${_ctx.iconLeft}.svg`)
                  }, null, 8, ["alt", "src"])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.prefix)
              ? (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: 
          `bg-gray-lp-1000 rounded-l-md text-black-lp-300 text-center my-1.5 ${
            _ctx.error || _ctx.errorMaxValueNumber || _ctx.errorMandatory
              ? 'border-red-lp-100'
              : 'border-gray-lp-400'
          } border outline-none focus:shadow flex items-center gap-x-1 text-12px xxl:text-14px px-4 pl-2`
        
                }, [
                  (_ctx.flag)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        alt: _ctx.flag,
                        src: require(`@/app/ui/assets/svg/flag/${_ctx.flag}.svg`)
                      }, null, 8, ["alt", "src"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.prefix), 1)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.isFloatingPrefixNumber)
              ? (_openBlock(), _createBlock("div", {
                  key: 2,
                  style: {"top":"1rem","margin-top":"0.5px"},
                  class: `absolute text-gray-lp-600 text-${_ctx.sizeInput} pl-4`
                }, " 0, ", 2))
              : _createCommentVNode("", true),
            (_ctx.showViewDisabledInput && _ctx.disabled)
              ? (_openBlock(), _createBlock("div", {
                  key: 3,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickInput && _ctx.onClickInput(...args))),
                  class: "py-2.5 px-3 rounded border focus:outline-none focus:shadow my-1.5 text-${sizeInput} bg-white text-gray-lp-600 cursor-not-allowed w-full my-1.5"
                }, _toDisplayString(_ctx.modelValue), 1))
              : (_openBlock(), _createBlock("input", {
                  key: 4,
                  id: _ctx.id,
                  ref: "inputForm",
                  autocomplete: _ctx.autocomplete,
                  value: _ctx.modelValue,
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateValue($event))),
                  onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.$emit('enter', $event.target.value)), ["enter"])),
                  onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('blur', $event.target.value))),
                  onFocus: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
                  type: _ctx.type,
                  placeholder: _ctx.placeholder,
                  minlength: _ctx.minLength,
                  maxlength: _ctx.maxLength,
                  min: _ctx.min,
                  max: _ctx.max,
                  disabled: _ctx.disabled,
                  class: 
          `${
            _ctx.labelStacked ? `pt-10 pb-4 ${_ctx.labelStackedCenter ? 'text-center' : ''}` : _ctx.sizeProportional
    } ${_ctx.isFloatingPrefixNumber ? 'px-8' : 'px-3'} text-${_ctx.sizeInput}
        ${!_ctx.suffix ? 'rounded-r-md border-r' : 'rounded-r-none border-r-none'}
        ${
          !_ctx.prefix && !_ctx.iconLeft ? 'rounded-l-md border-l' : 'rounded-l-none border-l-none'
        } border-t border-b
        ${
          _ctx.error || _ctx.errorMaxValueNumber || _ctx.errorMandatory
            ? 'border-red-lp-100'
            : 'border-gray-lp-400'
        }

        ${
          _ctx.disabled && _ctx.disableBackground
            ? `bg-gray-lp-1500 ${_ctx.isInputBlack ? 'text-gray-lp-300' : 'text-gray-lp-600'} cursor-not-allowed`
            : _ctx.disabled && !_ctx.disableBackground
            ? 'bg-white text-gray-lp-600 cursor-not-allowed'
            : 'bg-white text-black-lp-300'
        }

        ${_ctx.uppercase && 'uppercase'}
        ${_ctx.bold && 'font-bold'}
        focus:outline-none focus:shadow my-1.5 w-full ${_ctx.isCapitalize &&
          'capitalize'}`
        ,
                  onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"])),
                  style: _ctx.customStyle
                }, null, 46, ["id", "autocomplete", "value", "type", "placeholder", "minlength", "maxlength", "min", "max", "disabled"])),
            (_ctx.labelStacked)
              ? (_openBlock(), _createBlock("div", {
                  key: 5,
                  style: _ctx.labelStackedCenter ?  'top: 1rem;' : '',
                  class: `absolute text-gray-lp-600 ${!_ctx.labelStackedCenter ? 'pt-5 px-3' : 'flex items-center justify-center w-full pt-2' }`
                }, _toDisplayString(_ctx.labelStacked), 7))
              : _createCommentVNode("", true),
            (_ctx.maxLength && _ctx.showMaxLength && !_ctx.error)
              ? (_openBlock(), _createBlock("div", {
                  key: 6,
                  class: `pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 ${_ctx.disabled && _ctx.disableBackground ? 'text-gray-lp-600 cursor-not-allowed' : 'text-gray-700'}`
                }, [
                  _createVNode("p", {
                    class: `text-12px text-gray-lp-500 ${_ctx.disabled && _ctx.disableBackground ? 'bg-gray-lp-1500' :' bg-white'} py-1 px-1`
                  }, _toDisplayString(_ctx.modelValue?.length || 0) + "/" + _toDisplayString(_ctx.maxLength), 3)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.suffix)
              ? (_openBlock(), _createBlock("div", {
                  key: 7,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('onClickSuffix'))),
                  class: 
          `${_ctx.customClassSuffix} bg-gray-lp-1000 text-black-lp-300 rounded-r-md text-center my-1.5 ${
            _ctx.error || _ctx.errorMaxValueNumber || _ctx.errorMandatory
              ? 'border-red-lp-100'
              : 'border-gray-lp-400'
          } border outline-none focus:shadow flex items-center text-12px xxl:text-14px px-3`
        
                }, _toDisplayString(_ctx.suffix), 3))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode("div", {
              class: [`${_ctx.suffix && 'mr-12'}`, "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"]
            }, [
              _withDirectives(_createVNode("img", _hoisted_2, null, 512), [
                [_vShow, _ctx.isErrorIconInput]
              ])
            ], 2), [
              [_vShow, (_ctx.error || _ctx.errorMaxValueNumber || _ctx.errorMandatory) && _ctx.errorIcon]
            ]),
            _withDirectives(_createVNode("div", {
              class: [`${_ctx.suffix && 'mr-12'}`, "pointer-events-none absolute inset-y-0 right-0 flex items-center text-gray-700"]
            }, [
              _hoisted_3
            ], 2), [
              [_vShow, _ctx.inputChecked]
            ]),
            _renderSlot(_ctx.$slots, "suffix", {}, undefined, true)
          ], 64))
        : (_ctx.type === 'textarea')
          ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
              _createVNode("textarea", {
                id: _ctx.id,
                ref: "inputForm",
                value: _ctx.modelValue,
                onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateValue($event))),
                onFocus: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
                rows: _ctx.textAreaRows,
                minlength: _ctx.minLength,
                maxlength: _ctx.maxLength,
                placeholder: _ctx.placeholder,
                onKeydown: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.onEnterTextArea($event)), ["enter"])),
                class: 
          `pt-2 px-4 rounded border focus:outline-none focus:shadow my-1.5 text-${_ctx.sizeInput}
          ${_ctx.showMaxLength ? 'pb-12' : 'pb-2'}
            ${_ctx.error || !!_ctx.errorMinLength ? 'border-red-lp-100' : ''}
                   ${
                     _ctx.disabled && _ctx.disableBackground
                       ? 'bg-gray-lp-1500 text-gray-lp-600 cursor-not-allowed'
                       : _ctx.disabled && !_ctx.disableBackground
                       ? 'bg-white text-gray-lp-600 cursor-not-allowed'
                       : 'bg-white text-black-lp-300'
                   } w-full ${!_ctx.resizableTextarea ? 'resize-none' : 'resize-y'}`
        ,
                disabled: _ctx.disabled
              }, null, 42, ["id", "value", "rows", "minlength", "maxlength", "placeholder", "disabled"]),
              _createVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "footer-textarea", {}, undefined, true)
              ]),
              (_ctx.maxLength && _ctx.showMaxLength)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: `pointer-events-none absolute inset-y-0 right-0 flex items-end px-2 py-4 ${_ctx.disabled && _ctx.disableBackground ? ' text-gray-lp-600 cursor-not-allowed' : ' text-gray-700'}`
                  }, [
                    _createVNode("p", _hoisted_5, _toDisplayString(_ctx.modelValue?.length || 0) + "/" + _toDisplayString(_ctx.maxLength), 1)
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
    ], 2), [
      [_directive_click_outside, () => _ctx.$emit('click-outside')]
    ]),
    _withDirectives(_createVNode("div", _hoisted_6, [
      _withDirectives(_createVNode("img", _hoisted_7, null, 512), [
        [_vShow, _ctx.isErrorIconCaption]
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.errorMessage), 1)
    ], 512), [
      [_vShow, _ctx.error || _ctx.errorMaxValueNumber || _ctx.errorMandatory || !!_ctx.errorMinLength]
    ]),
    _withDirectives(_createVNode("div", {
      class: "text-gray-lp-500 text-12px",
      style: {"white-space":"nowrap"}
    }, _toDisplayString(_ctx.hint), 513), [
      [_vShow, _ctx.hint]
    ])
  ], 64))
})